import useSWR from "swr";
import { productDataType } from "../../../types/store-types";
import shippingInfoService from "../../../_foundation/apis/transaction/shippingInfo.service";
import stockService from "../../../_foundation/apis/transaction/stock.service";
import { swrOptionsNoRetry } from "./constants";
import { useLocation } from "react-router";
import * as ROUTES from "../../../constants/routes";

export const useShippingDate = (zipcode: string, skus: productDataType) => {
  const filteredSkus = skus?.filter((sku) => !sku.sku.includes("FPC")) || [];
  const products = filteredSkus.reduce((acc, sku) => {
    acc[sku.sku] = String(sku.quantity);
    return acc;
  }, {} as Record<string, string>);

  const payload = {
    widget: "useShippingDate",
    skipErrorSnackbar: true,
    body: { zipCode: zipcode, country: "FR", products },
  };

  const swrKey = zipcode && zipcode.length === 5 && Object.keys(products).length > 0 ? payload : null;
  return useSWR(swrKey, stockService.deliveryDate, swrOptionsNoRetry);
};

export const useShippingPrice = (payloadBase: any, orderId: string, skus?: productDataType) => {
  const { pathname } = useLocation();

  const isExcludedRoute = pathname.includes(ROUTES.ORDER_CONFIRMATION);
  const payload = {
    widget: "useShippingPrice",
    ...payloadBase,
    body: { orderId, skus: skus },
  };

  return useSWR(
    !isExcludedRoute && (skus || orderId) ? payload : null,
    shippingInfoService.getShippingPrice,
    swrOptionsNoRetry
  );
};
